export default __webpack_public_path__ + "static/media/support-open.50b571c0.svg";